import { useState } from 'react';
import { Button, Tooltip } from '@bancobarigui/barihaus';
import {
  AppstoreAddOutlined,
  FolderAddOutlined,
  QuestionOutlined ,
  UndoOutlined,
  RedoOutlined,
} from '@ant-design/icons';

interface FloatingControlsProps {
  onAddGroup: () => void;
  hasGroups: boolean;
  onDragStart?: (type: string) => void;
  onUndo?: () => void;
  canUndo?: boolean;
  onRedo?: () => void;
  canRedo?: boolean;
}

export const CONTROL_ITEMS = [
  { id: 'new-group', type: 'new-group', icon: <AppstoreAddOutlined />, label: 'Arraste para adicionar Grupo', color: '#1890ff' },
  { id: 'new-section', type: 'new-section', icon: <FolderAddOutlined />, label: 'Arraste para adicionar Seção em um Grupo', color: '#52c41a' },
  { id: 'new-question', type: 'new-question', icon: <QuestionOutlined  />, label: 'Arraste para adicionar Pergunta em uma Seção', color: '#faad14' },
];

export function FloatingControls({ onDragStart, onUndo, canUndo, onRedo, canRedo }: FloatingControlsProps) {
  const [draggedType, setDraggedType] = useState<string | null>(null);

  const handleDragStart = (e: React.DragEvent, type: string) => {
    setDraggedType(type);
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('text/plain', type);
    if (onDragStart) onDragStart(type);
  };

  const handleDragEnd = () => {
    setDraggedType(null);
    if (onDragStart) onDragStart('');
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 999,
      }}
      className="flex items-center gap-3 bg-white rounded-full shadow-lg px-6 py-3 border border-gray-200"
    >
      {CONTROL_ITEMS.map((item) => (
        <Tooltip key={item.id} title={item.label} placement="top">
          <div
            draggable
            onDragStart={(e) => handleDragStart(e, item.type)}
            onDragEnd={handleDragEnd}
            style={{
              backgroundColor: draggedType === item.type ? item.color : 'transparent',
              border: `2px solid ${item.color}`,
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'grab',
              transition: 'all 0.2s',
              color: draggedType === item.type ? '#fff' : item.color,
            }}
            className={draggedType === item.type ? 'opacity-70' : 'hover:opacity-80'}
          >
            {item.icon}
          </div>
        </Tooltip>
      ))}

      <div className="w-px h-8 bg-gray-300 mx-2" />

      <Tooltip title={canUndo ? "Desfazer última ação" : "Nenhuma ação para desfazer"} placement="top">
        <Button
          shape="circle"
          icon={<UndoOutlined />}
          disabled={!canUndo}
          onClick={onUndo}
          size="small"
          children={undefined}
        />
      </Tooltip>

      <Tooltip title={canRedo ? "Refazer última ação" : "Nenhuma ação para refazer"} placement="top">
        <Button
          shape="circle"
          icon={<RedoOutlined />}
          disabled={!canRedo}
          onClick={onRedo}
          size="small"
          children={undefined}
        />
      </Tooltip>
    </div>
  );
}
